export {
    Type,
    JSON,
    toCBOR,
    fromCBOR,
    registerCBOREncoder,
    registerCBORDecoder,
    fromAccountAddress,
    instanceOf,
    fromJSON,
    fromBase58,
    toBase58,
} from '../../plt/CborAccountAddress.js';
